import { render, staticRenderFns } from "./BaseInputGroup.vue?vue&type=template&id=05f1979a"
import script from "./BaseInputGroup.vue?vue&type=script&lang=js"
export * from "./BaseInputGroup.vue?vue&type=script&lang=js"
import style0 from "./BaseInputGroup.vue?vue&type=style&index=0&id=05f1979a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports